import { type SubscriberVisibilityKind } from "@relay/editSubscriberConfigButton_EditSubscriberConfigMutation.graphql";
import { FileV2 } from "../../../../features/files/file-selection-field";
import { type Product } from "../../../../features/products/select-product-field-dialog/select-product-field-dialog.interface";

export type { SubscriberVisibilityKind };

export const VISIBILITY_CONFIG_TYPE_TO_KIND: Record<string, SubscriberVisibilityKind> = {
	VisibilityTree_Hide: "HIDDEN",
	VisibilityTree_OnlyAdmins: "ONLY_ADMINS",
	VisibilityTree_OnlyBusinessAccount: "ONLY_BUSINESS_ACCOUNTS",
	VisibilityTree_OnlyWithLicense: "ONLY_WITH_LICENSE",
	VisibilityTree_OnlyEditors: "ONLY_EDITORS",
	VisibilityTree_OnlyAZAVAccount: "ONLY_AZAV_ACCOUNTS",
	VisibilityTree_AfterDateTime: "AFTER_DATE_TIME",
	VisibilityTree_NotAfterDateTime: "NOT_AFTER_DATE_TIME",
	VisibilityTree_OnlyPermissionsImpl: "ONLY_WITH_LICENSE",
};

export type EditSubscriberConfigFormState = {
	title: string;
	image: FileV2 | undefined;
	visibility: SubscriberVisibilityKind | null;
	dateTime: string | null;
	licenseProduct: Product | undefined;
	courseContentProduct: Product | undefined;
	certificationProduct: Product | undefined;
};

export type EditSubscriberConfigFormProps = {
	initialTitle: string | null;
	initialImageUrl: string | null;
	initialVisibility: SubscriberVisibilityKind | null;
	initialDateTime: string | null;
	initialLicenseProduct: Product | undefined;
	initialCourseContentProduct: Product | undefined;
	initialCertificationProduct: Product | undefined;
	onSubmit: (values: EditSubscriberConfigFormState) => void;
};
